<template>
    <div class="md-layout">

        <div class="md-layout-item md-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <div class="card-icon">
                                <i class="md-icon fas fa-layer-group"/>
                            </div>
                            <h4 class="title">Liste des catégories</h4>
                        </div>
                        <div class="md-layout-actions md-layout-item md-size-40 text-right align-center mt-3">
                            <div class="flex items-center">
                                <md-button class="md-info md-sm md-datatable" @click="goToRoute('Add Document Type')">
                                    <md-icon class="material-icons mr-1">add</md-icon>
                                    <span>Ajouter une catégorie</span>
                                </md-button>
                            </div>
                        </div>
                    </div>
                </md-card-header>
                <md-card-content class="mt-2">
                    <md-table v-model="documentTypes" table-header-color="blue">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <template v-if="item.parent_id === null">
                                <md-table-cell md-label="#">{{ item.id }}</md-table-cell>
                                <md-table-cell md-label="Nom" style="min-width: 850px">
                                    <span>{{ item.name }}</span>
                                    <div v-if="item.children.length > 0">
                                        <md-list class="md-dense">
                                            <md-list-item v-for="child in item.children" :key="child.id">
                                                <i class="md-icon fas fa-circle"/>
                                                <span class="md-list-item-text">{{ child.name }}</span>
                                            </md-list-item>
                                        </md-list>
                                    </div>
                                </md-table-cell>
                                <md-table-cell md-label="État" style="min-width: 75px">
                                    <span :class="item.is_active ? 'text-success' : 'text-danger'">
                                        {{ isActive(item.is_active) }}
                                    </span>
                                    <div v-if="item.children.length > 0">
                                        <md-list class="md-dense md-list-no-padding">
                                            <md-list-item v-for="child in item.children" :key="child.id">
                                                <span class="md-list-item-text" :class="child.is_active ? 'text-success' : 'text-danger'">{{ isActive(child.is_active) }}</span>
                                            </md-list-item>
                                        </md-list>
                                    </div>
                                </md-table-cell>
                                <md-table-cell md-label="Poids" style="max-width: 30px">
                                    <div class="edit-order">
                                        <md-field class="md-invalid md-parent-field">
                                            <md-input v-model="item.order" name="order" type="number" @keyup.enter="updateDocumentTypeOrder(item); $event.target.blur()"></md-input>
                                        </md-field>
                                    </div>
                                    <div v-if="item.children.length > 0" class="md-child-fields">
                                        <md-list class="md-dense md-list-no-padding md-list-no-margin">
                                            <md-list-item v-for="child in item.children" :key="child.id">
                                                <div class="edit-order">
                                                    <md-field class="md-invalid">
                                                        <md-input v-model="child.order" name="order" type="number" @keyup.enter="updateDocumentTypeOrder(child); $event.target.blur()"></md-input>
                                                    </md-field>
                                                </div>
                                            </md-list-item>
                                        </md-list>
                                    </div>
                                </md-table-cell>
                                <md-table-cell md-label="" style="min-width: 75px">
                                    <div class="w-full flex items-center justify-center">
                                        <div>
                                            <md-button class="md-icon-button md-raised md-warning"
                                                       @click="goToRoute('Edit Document Type', item.id)">
                                                <i class="md-icon fa fa-pen"/>
                                            </md-button>
                                            <md-tooltip md-direction="top">Gérer</md-tooltip>
                                        </div>
                                    </div>
                                </md-table-cell>
                            </template>
                        </md-table-row>
                    </md-table>
                </md-card-content>
            </md-card>
        </div>

        <div class="md-layout-item md-size-100">
            <documents-table
                :documents-data="documents"
                @updated="getData" @deleted="getData"></documents-table>
        </div>

    </div>
</template>

<script>
import DocumentsTable from "@/pages/Documents/components/DocumentsTable";

export default {
    name: "Documents",
    components: {
        DocumentsTable
    },
    data() {
        return {
            documents: [],
            documentTypes: [],
        }
    },
    methods: {
        isActive(state) {
            return state ? "Actif" : "Inactif"
        },
        goToRoute(route, id = null) {
            this.$router.push({ name: route, params: { idType: id }})
        },
        async getData() {
            let documentsData = await this.$store.dispatch('documents/getDocuments')
            let documentTypesData = await this.$store.dispatch('documents/getDocumentTypes')
            this.documents = documentsData.data
            this.documentTypes = documentTypesData.data
        },
        async updateDocumentTypeOrder(type) {
            let documentType = {
                ...type,
                order: parseInt(type.order)
            }
            try {
                const { data } = await this.$store.dispatch('documents/updateDocumentTypeOrder', documentType)
                if(data === 'same order') {
                    await this.$store.dispatch('alerts/warning', 'Poids identique')
                } else {
                    await this.$store.dispatch('alerts/success', 'Poids modifié')
                    await this.getData()
                }
            } catch (e) {
                await this.$store.dispatch('alerts/error', e.response.data.errors[0].detail)
            }
        }
    },
    mounted() {
        this.getData()
    }
}
</script>
<style scoped lang="scss">
::v-deep {
    .md-datatable {
        max-height: 33px;
        min-height: 33px;
        width: 100%;

        .md-ripple {
            padding: 0 1rem !important;
        }
    }

    .md-layout-actions.md-layout-item {
        padding-right: 0;
    }

    .md-button-content {
        i {
            font-size: 1.1rem !important;
            height: 17px !important;
            width: 15px !important;
            min-width: 15px !important;
        }

        span {
            height: 17px;
            line-height: 18px;
        }
    }

    .md-table-cell-container .md-button {
        width: auto;

        .md-icon {
            font-size: .875rem !important;
            min-width: .875rem !important;
            height: .875rem !important;
        }
    }

    .md-table-head .md-table-head-label {
        color: #00bcd4 !important;
    }

    .md-list.md-dense {
        padding: 0;
        margin-top: .5rem;

        .md-list-item-content.md-ripple {
            min-height: 25px;
            padding: 0 15px;

            .md-icon {
                font-size: .25rem !important;
                min-width: .25rem !important;
                height: .25rem !important;
                color: rgba(0, 0, 0, .54) !important;
            }

            .md-icon:first-child {
                margin-right: .5rem;
            }

            span {
                position: relative;
                font-weight: 300;
                font-size: 14px;
            }
        }
    }

    .md-list.md-list-no-padding {
        margin-top: 6px;

        &.md-list-no-margin {
            margin-top: 0;
        }
        .md-list-item {
            margin: 0;

            .md-list-item-content.md-ripple {
                padding: 0;
            }
        }
    }

    .edit-order {
        .md-field {
            margin-top: 0;
            padding-bottom: 5px;
            input {
                width: 100%;
                height: 20px;
                padding: 0 !important;
            }
            input[type=number] {
                -moz-appearance: textfield;
            }

            &:before, &:after {
                bottom: 4px;
            }
        }

        .md-field.md-parent-field + .md-child-fields {
            margin-top: -3px;
            margin-bottom: 3px;
        }
    }
}
</style>
